export default "https://assets.pclncdn.com/web/next-landing/bc028b7/_next/static/images/los-angeles-c95bf6438b19d05d7a108c8747178b68.jpg";